import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../AppIcon";
import { useNavigation } from "components/ui/NavigationStateManager";
import PinModal from "pages/HomePage/components/PinModal";

const Header = () => {
  const {
    currentStore,
    anonymousMode,
    handleStoreSelection,
    handleAnonymousModeToggle,
    getDisplayStoreName,
    loader,
    stores,
    getAnonymousName,
  } = useNavigation();
  const [pinStatus, setPinStatus] = useState(() => {
    return sessionStorage.getItem("pinStatus") === "true";
  });
  const [isStoreDropdownOpen, setIsStoreDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsStoreDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isHomePage =
    location.pathname === "/HomePage" || location.pathname === "/";

  const isListingPage = location.pathname === "/product-listing-page";

  const filteredStores = stores.filter((store) => store.sBrandName);

  return (
    <header className="fixed top-0 left-0 right-0 bg-surface border-b border-border z-1000">
      <div className="container-app">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/HomePage"
            className="flex items-center space-x-3 hover:opacity-80 transition-smooth"
          >
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Zap" size={20} color="white" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-semibold text-text-primary">
                VTO Demo
              </span>
            </div>
          </Link>
          <PinModal setPinStatus={setPinStatus} />
          {!isHomePage && currentStore && (
            <div className="hidden md:flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm text-text-secondary">
                <Icon name="Store" size={16} />
                <span>Demo Environment:</span>
                <span className="font-medium text-text-primary">
                  {getDisplayStoreName()}
                </span>
              </div>
            </div>
          )}
          <div className="flex items-center space-x-4">
            {pinStatus ? (
              <div className="flex items-center space-x-2">
                <span className="text-sm text-text-secondary hidden sm:block">
                  Anonymous
                </span>
                <button
                  onClick={handleAnonymousModeToggle}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-smooth focus-ring ${
                    anonymousMode ? "bg-primary" : "bg-secondary-300"
                  }`}
                  aria-label="Toggle anonymous mode"
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-smooth ${
                      anonymousMode ? "translate-x-6" : "translate-x-1"
                    }`}
                  />
                </button>
              </div>
            ) : null}

            {isListingPage && (
              <div className="relative" ref={dropdownRef}>
                <button
                  disabled={loader}
                  onClick={() => setIsStoreDropdownOpen(!isStoreDropdownOpen)}
                  className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-text-primary bg-secondary-50 hover:bg-secondary-100 rounded-md transition-smooth focus-ring"
                >
                  <Icon name="Building2" size={16} />
                  <span className="hidden sm:block">
                    {getDisplayStoreName() || "Switch Store"}
                  </span>
                  <Icon
                    name={isStoreDropdownOpen ? "ChevronUp" : "ChevronDown"}
                    size={16}
                  />
                </button>

                {isStoreDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-64 bg-surface rounded-lg shadow-lg border border-border animate-fade-in z-1010">
                    <div className="p-2">
                      <div className="text-xs font-medium text-text-secondary px-3 py-2 border-b border-border-light">
                        Available Demo
                      </div>
                      <div className="mt-2 space-y-1">
                        {filteredStores.map((store, index) => (
                          <button
                            key={store.iTenantId}
                            onClick={() => {
                              handleStoreSelection(store);
                              setIsStoreDropdownOpen(false);
                            }}
                            className={`relative group w-full text-left px-3 py-2 text-sm rounded-md transition-smooth hover:bg-secondary-50 ${
                              currentStore?.iTenantId === store.iTenantId
                                ? "bg-primary-50 text-primary font-medium"
                                : "text-text-primary"
                            }`}
                          >
                            <div className="flex items-center justify-between">
                              <span>
                                {anonymousMode
                                  ? getAnonymousName(store.iTenantId)
                                  : store.sBrandName}
                              </span>
                              {currentStore?.iTenantId === store.iTenantId && (
                                <Icon
                                  name="Check"
                                  size={16}
                                  color="currentColor"
                                />
                              )}
                            </div>
                            <div className="absolute left-1/2 top-0 translate-x-4 translate-y-[-100%] px-2 py-1 text-xs bg-black text-white rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 max-w-xs break-words whitespace-pre-line">
                              <>Best for {store?.productTypes?.join(", ")}</>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
